import styles from './Logo.module.scss';
import LogoSVG from '../../../../../../public/images/logo.svg';
import LogoUSSVG from '../../../../../../public/images/logo-us.svg';
import Link from 'next/link';
import { useLocale, OutputChannels } from 'src/modules/locale';
import React from 'react';
import classnames from 'classnames';

export interface LogoProps {
  className?: string;
  size?: 'large' | 'small';
}

export const Logo = ({ className, size = 'small' }: LogoProps) => {
  const { outputChannel } = useLocale();

  if (!outputChannel) return null;

  return (
    <Link as="/" href="/">
      <a className={classnames(className, styles.logoContainer)} style={{ color: 'inherit' }}>
        {outputChannel === OutputChannels.US ? (
          <LogoUSSVG
            className={classnames(styles.logoUs, size === 'small' ? styles.small : styles.large)}
          />
        ) : (
          <LogoSVG
            className={classnames(styles.logo, size === 'small' ? styles.small : styles.large)}
          />
        )}
      </a>
    </Link>
  );
};
